import type { PublicProductDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { STORE_DETAIL_INFO_ID } from '@/shared/config';
import { formatCount } from '@/shared/lib';

interface ProductionInfoTableProps {
  readonly detail: PublicProductDetail;
}

const ROWS = [
  {
    label: '최소 주문 수량',
    value: (d: PublicProductDetail) => `${formatCount(d.minOrderQty)}개`,
  },
  { label: '소재', value: (d: PublicProductDetail) => d.materialNote },
  {
    label: '크기',
    value: (d: PublicProductDetail) =>
      d.widthMm === null || d.heightMm === null ? '-' : `${d.widthMm} × ${d.heightMm} mm`,
  },
  { label: '납기', value: (d: PublicProductDetail) => d.leadTimeNote },
  { label: '제작 조건', value: (d: PublicProductDetail) => d.productionNote },
] as const;

/**
 * 제작 정보 — 소재·크기·납기·제작 조건(와이어프레임 5행).
 * 상자 없이 얇은 선으로 나눈 이름/값 줄이다. 이름 칸은 폭을 고정해 값의 시작선을 맞춘다.
 */
export const ProductionInfoTable = ({ detail }: ProductionInfoTableProps): ReactElement => (
  <section aria-labelledby={STORE_DETAIL_INFO_ID} className="scroll-mt-28">
    {/* 바로가기 탭이 같은 이름을 보여 주므로 제목은 화면낭독기에만 남긴다. */}
    <h2 id={STORE_DETAIL_INFO_ID} className="sr-only">
      제작 정보
    </h2>
    <dl className="divide-y divide-foreground/10 text-sm">
      {ROWS.map((row) => (
        <div key={row.label} className="flex gap-4 py-3">
          <dt className="w-28 shrink-0 text-muted-foreground">{row.label}</dt>
          <dd className="min-w-0 flex-1">{row.value(detail)}</dd>
        </div>
      ))}
    </dl>
  </section>
);
